import { useEffect, useRef } from 'react'

import { useDocumentTitleStore } from './document-title-store'
import type { DocumentTitleSegment } from './format-document-title'

function segmentsKey(segments: ReadonlyArray<DocumentTitleSegment>): string {
  return segments.map((s) => (typeof s === 'string' ? s : ' ')).join('')
}

export function useDocumentTitle(
  ...segments: ReadonlyArray<DocumentTitleSegment>
): void {
  const key = segmentsKey(segments)
  const segmentsRef = useRef<ReadonlyArray<DocumentTitleSegment>>(segments)
  // The product's latest-value-ref pattern, kept verbatim: the effect below
  // keys on the string form and reads the object form through the ref, so a
  // caller passing a fresh array each render re-titles once, not every render.
  // eslint-disable-next-line react-hooks/refs
  segmentsRef.current = segments

  useEffect(() => {
    const snapshot = segmentsRef.current
    const { setSegments, clearSegments } = useDocumentTitleStore.getState()
    setSegments(snapshot)
    return () => {
      clearSegments(snapshot)
    }
  }, [key])
}
